module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-lace straps-Ka-La.2567d1d3.png";